<template>
  <div class="__dropdown-wrapper">
    <label class="__dropdown-label" v-if="label">{{label}}</label>
    <div @click="toggle" v-on-clickaway="away" class="__dropdown" @keydown.esc="open = false">
      <button :disabled="disabled" :id="customId" :class="['__dropdown-control', isSelected && 'selected', open && 'focused']">
        <span class="__dropdown-control-value">{{controlValue}}</span>
        <i class="fak fa-angle-down-regular"/>
      </button>
      <transition name="dropdown">
        <div v-if="open" class="__dropdown-options-box">
          <div class="__dropdown-options">
            <div
              class="__dropdown-option"
              v-for="(option, index) in options"
              @click="selectOption(option)"
              :key="option?.value + index">
              {{option?.label}}
            </div>
            <div class="__dropdown-empty" v-if="!options?.length">No options</div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
// todo описать ошибки для дропдауна
import Vue from 'vue'
import { mixin as clickaway } from 'vue-clickaway'
import uniqueId from "lodash.uniqueid";
export default Vue.extend({
  mixins: [ clickaway ],
  emits: ['on-change'],
  data () {
    return {
      open: false,
      customId: uniqueId('dropdown')
    }
  },
  props: {
    placeholder: {
      type: String,
      default: 'Select option'
    },
    selected: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: undefined
    }
  },
  computed: {
    isSelected() {
      return !!this.$props.selected
    },
    controlValue() {
      return this.isSelected ? this.$props?.selected?.label : this.$props.placeholder
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
    away() {
      this.open = false
    },
    selectOption(value) {
      this.$emit('on-change',value)
    }
  }
})
</script>
<style lang="scss" scoped>;
.__dropdown-label {
  font-family: Segoe UI, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  transition: 0.2s ease-in;
}
.__dropdown {
  position: relative;
  font-family: Segoe UI, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  &-control {
    width: 100%;
    padding: 10px 16px;
    display: flex;
    height: 40px;
    justify-content: space-between;
    background-color: white;
    border-radius: 6px;
    border: 1px solid $color-gray-light-2;
    transition: 0.2s ease-in;
    i {
      color: $color-main-text;
    }
    span {
      transition: 0.2s ease-in;
      color: $color-secondary-text;
    }
    &.selected {
      span {
        color: $color-main-text
      }
    }
    &:hover:not(:disabled) span{
      color: $color-secondary-text;
    }
    &.focused {
      border: 1px solid #7DABEF;
      box-shadow: 0 0 4px 0 #86B7FE;
    }
    &:disabled {
      background-color: $color-gray-light;
      span {
        color: $color-secondary-text;
      }
    }
  }
  &-options-box {
    border-radius: 4px;
    overflow: hidden;
    width: 100%;
    position: absolute;
    background-color: white;
    max-height: 136px;
    z-index: 10;
    box-shadow: 4px 4px 8px rgba(0,0,0,.15);
    border: 1px solid $color-gray-light-2;
  }
  &-options {
    overflow-y: auto;
    max-height: inherit;
    &::-webkit-scrollbar {
      width: 6px;
    }
    .__dropdown-option {
      cursor: pointer;
      padding: 8px 16px;
      transition: 0.2s ease-in;
      line-height: 18px;
      &:hover {
        background-color: $color-blue-light;
      }
    }
    .__dropdown-empty {
      height: 68px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: $color-secondary-text;
    }
  }
  .dropdown-enter-active, .dropdown-leave-active {
    transition: all .3s;
  }
  .dropdown-enter, .dropdown-leave-to {
    opacity: 0;
    transform: translateY(15px);
  }
}
</style>